import {
  LogOutDetails,
  LogOutActionTypes,
  LOG_OUT_FAIL,
  LOG_OUT_LOADING,
  LOG_OUT_SUCCESS,
} from "./ActionTypes";
import { LogOutResponse } from "./Model";

const initialStateGetPosts: LogOutDetails = {
  loading: false,
  logOutRes: {} as LogOutResponse,
  message: "",
  status: 0,
};
export const logOutReducer = (
  state = initialStateGetPosts,
  action: LogOutActionTypes
): LogOutDetails => {
  switch (action.type) {
    case LOG_OUT_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case LOG_OUT_SUCCESS:
      return {
        ...state,
        logOutRes: action.payload,
      };
    case LOG_OUT_FAIL:
      return {
        ...state,
        logOutRes: {} as LogOutResponse,
        message: action.message,
        status: action.status,
      };
    default:
      return state;
  }
};
